
	import { defineComponent } from 'vue';
	import JsonView from '@/JsonView.vue';

	export default defineComponent({
		name      : 'ServeDev',
		components: { JsonView },
		data() {
			return {
				events: [] as string[],
				dark  : false
			};
		},
		methods : {
			itemSelected(data: any): void {
				this.events.push(`Selected: ${data.path} with value ${data.value}`);
			}
		},
		computed: {
			data() {
				return {
					first    : 'level',
					works    : true,
					number   : 100,
					missing  : null,
					undefined: undefined,
					list     : [
						'fun',
						{
							test: {
								passed: true
							}
						}
					],
					object   : {
						working: 'properly'
					}
				};
			},
			colorScheme(): string {
				return this.dark ? 'dark' : 'light';
			}
		}
	});
